/*
 * Calculadora de techo de crecimiento (sections/growth-calculator.liquid).
 * Cada mes se cancela un % fijo de la base y entran A nuevos: S_t = S_{t-1} × (1 − ch) + A.
 * La base tiende al techo A / ch. El Goal arranca igual que el Current y solo cambia al
 * aplicar un camino (bajar churn o subir adquisición). Todo se guarda sin redondear;
 * solo se redondea al mostrar.
 */
(function () {
  var MONTHS = 24;
  var MIN_CHURN = 0.1;
  var CURRENCIES = ['USD', 'MXN', 'GBP', 'EUR'];
  var SYMBOLS = { USD: '$', MXN: 'MX$', GBP: '£', EUR: '€' };
  var FIELDS = ['startingSubscribers', 'monthlyAcquired', 'churnRate', 'arpu', 'targetSubscribers'];
  // Tipo de lectura y rango permitido por campo (brief: tabla de Inputs).
  var RULES = {
    startingSubscribers: { kind: 'int', min: 0, max: 10000000 },
    monthlyAcquired: { kind: 'int', min: 0, max: 1000000 },
    churnRate: { kind: 'rate', min: MIN_CHURN, max: 100 },
    arpu: { kind: 'amount', min: 0, max: 100000 },
    targetSubscribers: { kind: 'int', min: 1, max: 10000000 },
  };
  var FALLBACKS = { startingSubscribers: 5000, monthlyAcquired: 1200, churnRate: 15, arpu: 50, targetSubscribers: 10000 };
  var URL_KEYS ={ subs: 'startingSubscribers', new: 'monthlyAcquired', churn: 'churnRate', arpu: 'arpu', target: 'targetSubscribers' };
  var PATHS = ['churn', 'acq'];

  /* ---------------------------- Funciones puras ---------------------------- */

  // Proyección de 0 a 24 meses.
  function project(l, months) {
    var n = months === undefined ? MONTHS : months;
    var c = 1 - l.churnRate / 100;
    var s = [l.startingSubscribers];
    for (var t = 1; t <= n; t++) s.push(s[t - 1] * c + l.monthlyAcquired);
    return s.map(function (v) { return { subs: v, mrr: v * l.arpu }; });
  }

  function ceiling(l) {
    return l.monthlyAcquired / (l.churnRate / 100);
  }

  // Incluye el mes 0, igual que la referencia.
  function cumulative(proj, n) {
    return proj.slice(0, (n === undefined ? 12 : n) + 1).reduce(function (sum, m) { return sum + m.mrr; }, 0);
  }

  // Qué tendría que cambiar para que el techo sea T, con todo lo demás igual.
  function solveChurn(l, T) {
    return (l.monthlyAcquired / T) * 100; // en %
  }

  function solveAcquisition(l, T) {
    return T * (l.churnRate / 100);
  }

  function inRange(key, v) {
    var r = RULES[key];
    return typeof v === 'number' && Number.isFinite(v) && v >= r.min && v <= r.max;
  }

  function leversValid(l) {
    return ['startingSubscribers', 'monthlyAcquired', 'churnRate', 'arpu'].every(function (k) { return inRange(k, l[k]); });
  }

  /*
   * Todo lo que pinta la página, o null si falta algún input de hoy.
   * path = 'churn' | 'acq' | null. Si la meta ya se alcanza, no hay camino y el Goal
   * queda igual al Current. Si el churn no alcanza la meta, se aplica adquisición,
   * para que siempre haya un camino seleccionado.
   */
  function compute(l, path) {
    if (!leversValid(l)) return null;
    var current = {
      startingSubscribers: l.startingSubscribers,
      monthlyAcquired: l.monthlyAcquired,
      churnRate: l.churnRate,
      arpu: l.arpu,
    };
    var ceilCur = ceiling(current);
    var hasTarget = inRange('targetSubscribers', l.targetSubscribers);
    var reached = hasTarget && l.targetSubscribers <= ceilCur;
    var churnNeeded = hasTarget && !reached ? solveChurn(current, l.targetSubscribers) : null;
    var acqNeeded = hasTarget && !reached ? solveAcquisition(current, l.targetSubscribers) : null;
    var churnReachable = churnNeeded !== null && churnNeeded >= MIN_CHURN;

    var applied = null;
    if (path === 'churn' && churnReachable) applied = 'churn';
    if (path === 'acq' && acqNeeded !== null) applied = 'acq';
    if (path === 'churn' && !churnReachable && acqNeeded !== null) applied = 'acq';

    // Solo un camino a la vez: la otra palanca del Goal se queda en su valor Current.
    var goal = {
      startingSubscribers: current.startingSubscribers,
      monthlyAcquired: applied === 'acq' ? acqNeeded : current.monthlyAcquired,
      churnRate: applied === 'churn' ? churnNeeded : current.churnRate,
      arpu: current.arpu,
    };

    var projCur = project(current);
    var projGoal = project(goal);
    var ceilGoal = ceiling(goal);
    var cumCur = cumulative(projCur);
    var cumGoal = cumulative(projGoal);

    return {
      applied: applied,
      hasTarget: hasTarget,
      reached: reached,
      churnNeeded: churnNeeded,
      churnReachable: churnReachable,
      acqNeeded: acqNeeded,
      current: { proj: projCur, ceiling: ceilCur, ceilingMrr: ceilCur * l.arpu, cumulative: cumCur },
      goal: { proj: projGoal, ceiling: ceilGoal, ceilingMrr: ceilGoal * l.arpu, cumulative: cumGoal },
    };
  }

  /*
   * Lectura de un campo de texto: { value, error, empty }. Vacío no es error.
   * Enteros ignoran comas ("10,000"); en churn la coma es decimal; en ARPU,
   * coma + 3 dígitos = miles y coma + 1 o 2 = decimal, igual que en la de ROI.
   */
  function parseField(key, raw) {
    var rule = RULES[key];
    var text = String(raw === null || raw === undefined ? '' : raw).trim();
    if (text === '') return { value: NaN, error: null, empty: true };
    var clean = text.replace(/MX\$/gi, '').replace(/[$£€%\s]/g, '');
    var value;
    if (rule.kind === 'int') {
      clean = clean.replace(/,/g, '');
      if (!/^\d+$/.test(clean)) return { value: NaN, error: 'Enter a whole number.', empty: false };
      value = parseInt(clean, 10);
    } else {
      if (rule.kind === 'rate') clean = clean.replace(/,/g, '.');
      else clean = clean.replace(/,(\d{3})(?=$|[.,])/g, '$1').replace(/,(?=\d{1,2}$)/, '.');
      if (!/^(\d+\.?\d*|\.\d+)$/.test(clean)) return { value: NaN, error: 'Numbers only here', empty: false };
      value = parseFloat(clean);
    }
    if (!inRange(key, value)) {
      return { value: NaN, error: 'Enter a value between ' + formatInt(rule.min) + ' and ' + formatInt(rule.max) + '.', empty: false };
    }
    return { value: value, error: null, empty: false };
  }

  /* ------------------------------- Formato -------------------------------- */

  function formatInt(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  function formatPct(n) {
    return n.toLocaleString('en-US', { maximumFractionDigits: 2 }) + '%';
  }

  function formatMoney(n, currency) {
    return SYMBOLS[currency] + formatInt(Math.abs(n));
  }

  // Change con signo + o −; cero sin signo.
  function signed(n, fmt) {
    var r = Math.round(n);
    if (r === 0) return fmt(0);
    return (r > 0 ? '+' : '−') + fmt(Math.abs(n));
  }

  function moneyText(n, currency) {
    return (Math.round(n) < 0 ? '−' : '') + formatMoney(n, currency);
  }

  // Para mostrar en un input: miles con coma y hasta 2 decimales.
  function toFieldValue(key, n) {
    if (!Number.isFinite(n)) return '';
    if (RULES[key].kind === 'rate') return String(Math.round(n * 100) / 100);
    return (Math.round(n * 100) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }

  function track(name, params) {
    try {
      if (Array.isArray(window.dataLayer)) {
        var payload = { event: name };
        Object.keys(params || {}).forEach(function (k) { payload[k] = params[k]; });
        window.dataLayer.push(payload);
      }
    } catch (e) {}
  }

  function hexToRgba(color, alpha) {
    var hex = String(color || '').trim().replace('#', '');
    if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
    if (!/^[0-9a-f]{6}$/i.test(hex)) return color;
    var n = parseInt(hex, 16);
    return 'rgba(' + (n >> 16) + ', ' + ((n >> 8) & 255) + ', ' + (n & 255) + ', ' + alpha + ')';
  }

  /* --------------------------------- DOM ---------------------------------- */

  function init(root) {
    var fields = {};
    root.querySelectorAll('[data-gc-field]').forEach(function (el) { fields[el.getAttribute('data-gc-field')] = el; });
    var errorEls = {};
    root.querySelectorAll('[data-gc-error]').forEach(function (el) { errorEls[el.getAttribute('data-gc-error')] = el; });
    var outputs = {};
    root.querySelectorAll('[data-gc-out]').forEach(function (el) { outputs[el.getAttribute('data-gc-out')] = el; });
    var cards = {};
    root.querySelectorAll('[data-gc-path]').forEach(function (el) { cards[el.getAttribute('data-gc-path')] = el; });
    var symbols = root.querySelectorAll('[data-gc-symbol]');
    var toggles = root.querySelectorAll('[data-gc-mode]');
    var pathsWrap = root.querySelector('[data-gc-paths]');
    var reachedMsg = root.querySelector('[data-gc-reached]');
    var legendGoal = root.querySelectorAll('[data-gc-legend-goal]');
    var canvas = root.querySelector('[data-gc-chart]');
    var cta = root.querySelector('[data-gc-cta]');
    var copyBtn = root.querySelector('[data-gc-copy]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Ejemplos para los placeholders (settings de la sección; si alguno es inválido, el del brief).
    // Los campos cargan vacíos y los ejemplos nunca entran al cálculo, igual que en la de ROI.
    var examples = {};
    FIELDS.forEach(function (key) {
      var parsed = parseField(key, root.dataset['default' + key.charAt(0).toUpperCase() + key.slice(1)]);
      examples[key] = parsed.error || parsed.empty ? FALLBACKS[key] : parsed.value;
    });

    var state = {
      currency: CURRENCIES.indexOf(root.dataset.currency) !== -1 ? root.dataset.currency : 'USD',
      path: 'churn', // el primer camino viene preseleccionado
      mode: 'subs',
    };
    FIELDS.forEach(function (key) { state[key] = NaN; });
    var errors = {};
    var shownErrors = {};
    var chart = null;
    var lastResult = null;

    readUrl();
    FIELDS.forEach(function (key) {
      fields[key].value = toFieldValue(key, state[key]);
      fields[key].placeholder = 'e.g. ' + toFieldValue(key, examples[key]);
    });
    fields.currency.value = state.currency;

    // Parámetros inválidos o fuera de rango se ignoran y el campo queda vacío.
    function readUrl() {
      var params = new URLSearchParams(window.location.search);
      Object.keys(URL_KEYS).forEach(function (param) {
        if (!params.has(param)) return;
        var parsed = parseField(URL_KEYS[param], params.get(param));
        if (!parsed.error && !parsed.empty) state[URL_KEYS[param]] = parsed.value;
      });
      var cur = (params.get('cur') || '').toUpperCase();
      if (CURRENCIES.indexOf(cur) !== -1) state.currency = cur;
      if (PATHS.indexOf(params.get('path')) !== -1) state.path = params.get('path');
      if (params.get('view') === 'mrr') state.mode = 'mrr';
    }

    // Solo los parámetros de la calculadora, siempre en el mismo orden.
    function calcParams() {
      var params = new URLSearchParams();
      Object.keys(URL_KEYS).forEach(function (param) {
        var v = state[URL_KEYS[param]];
        if (Number.isFinite(v)) params.set(param, String(Math.round(v * 10000) / 10000));
      });
      if (lastResult && lastResult.applied) params.set('path', lastResult.applied);
      params.set('cur', state.currency);
      if (state.mode === 'mrr') params.set('view', 'mrr');
      return params;
    }

    // La barra de direcciones conserva los parámetros ajenos (preview_theme_id, utm_*…).
    function writeUrl() {
      var params = new URLSearchParams(window.location.search);
      Object.keys(URL_KEYS).concat(['path', 'cur', 'view']).forEach(function (k) { params.delete(k); });
      calcParams().forEach(function (v, k) { params.set(k, v); });
      try {
        window.history.replaceState(null, '', window.location.pathname + '?' + params.toString() + window.location.hash);
      } catch (e) {}
    }

    // El link para compartir usa el dominio principal y la ruta canónica de la página,
    // no la dirección actual (que puede ser myshopify.com o una vista previa del tema).
    function shareUrl() {
      var base = (root.dataset.shareUrl || '').split(/[?#]/)[0];
      if (!/^https?:\/\//.test(base)) base = window.location.origin + window.location.pathname;
      return base + '?' + calcParams().toString();
    }

    function readField(key) {
      var parsed = parseField(key, fields[key].value);
      state[key] = parsed.value;
      errors[key] = parsed.error;
      if (shownErrors[key]) {
        if (parsed.error) showError(key);
        else hideError(key);
      }
    }

    function showError(key) {
      var input = fields[key];
      var el = errorEls[key];
      shownErrors[key] = true;
      input.setAttribute('aria-invalid', 'true');
      if (el) {
        el.textContent = errors[key];
        el.hidden = false;
        input.setAttribute('aria-describedby', el.id);
      }
    }

    function hideError(key) {
      var input = fields[key];
      var el = errorEls[key];
      shownErrors[key] = false;
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      if (el) {
        el.textContent = '';
        el.hidden = true;
      }
    }

    function setText(key, text) {
      if (outputs[key]) outputs[key].textContent = text;
    }

    function setChange(key, n, fmt) {
      var el = outputs[key];
      if (!el) return;
      el.textContent = n === null ? '—' : signed(n, fmt);
      el.classList.toggle('gc-positive', n !== null && Math.round(n) > 0);
      el.classList.toggle('gc-negative', n !== null && Math.round(n) < 0);
    }

    function renderCard(path, r) {
      var card = cards[path];
      if (!card) return;
      var valueEl = card.querySelector('[data-gc-card-value]');
      var fromEl = card.querySelector('[data-gc-card-from]');
      var btn = card.querySelector('[data-gc-apply]');
      var applied = !!(r && r.applied === path);
      var available = false;

      if (path === 'churn') {
        if (r && r.churnNeeded !== null && r.churnReachable) {
          valueEl.textContent = formatPct(r.churnNeeded);
          fromEl.textContent = 'down from ' + formatPct(state.churnRate);
          available = true;
        } else if (r && r.churnNeeded !== null) {
          valueEl.textContent = '—';
          fromEl.textContent = 'Not reachable by lowering churn alone.';
        } else {
          valueEl.textContent = '—';
          fromEl.textContent = '';
        }
      } else if (r && r.acqNeeded !== null) {
        valueEl.textContent = formatInt(r.acqNeeded) + '/mo';
        fromEl.textContent = 'up from ' + formatInt(state.monthlyAcquired) + '/mo';
        available = true;
      } else {
        valueEl.textContent = '—';
        fromEl.textContent = '';
      }

      card.classList.toggle('gc-path--applied', applied);
      card.classList.toggle('gc-path--unavailable', !available);
      btn.disabled = !available;
      btn.textContent = applied ? 'Applied' : 'Apply this path';
      btn.setAttribute('aria-pressed', applied ? 'true' : 'false');
    }

    function themeColor(name, fallback) {
      var v = window.getComputedStyle(root).getPropertyValue(name).trim();
      return v || fallback;
    }

    function chartSeries(r) {
      var key = state.mode === 'mrr' ? 'mrr' : 'subs';
      var mult = state.mode === 'mrr' ? state.arpu : 1;
      return {
        cur: r.current.proj.map(function (m) { return m[key]; }),
        goal: r.goal.proj.map(function (m) { return m[key]; }),
        ceilCur: r.current.ceiling * mult,
        ceilGoal: r.goal.ceiling * mult,
      };
    }

    function axisText(v) {
      return state.mode === 'mrr' ? moneyText(v, state.currency) : formatInt(v);
    }

    function buildChart() {
      if (chart || !canvas || typeof window.Chart === 'undefined') return;
      var Chart = window.Chart;
      var plugin = window['chartjs-plugin-annotation'];
      if (plugin && !Chart.registry.plugins.get('annotation')) Chart.register(plugin);

      var text = themeColor('--gc-text', '#FFFFFF');
      var accent = themeColor('--gc-accent', '#ED66B6');
      var currentColor = hexToRgba(text, 0.55);
      var grid = hexToRgba(text, 0.08);
      var gap = hexToRgba(accent, 0.18);
      var font = { family: "'Replica', sans-serif", size: 12 };
      var label = {
        display: true,
        backgroundColor: 'transparent',
        color: text,
        font: { family: "'Replica', sans-serif", size: 12 },
        yAdjust: -10,
        padding: 0,
      };

      chart = new Chart(canvas, {
        type: 'line',
        data: {
          labels: Array.from({ length: MONTHS + 1 }, function (_, i) { return i; }), // meses 0 a 24
          datasets: [
            { label: 'Current', data: [], borderColor: currentColor, backgroundColor: currentColor, borderWidth: 2, pointRadius: 0, pointHoverRadius: 4, tension: 0.3 },
            {
              label: 'Goal', data: [], borderColor: accent, backgroundColor: accent, borderWidth: 2, pointRadius: 0, pointHoverRadius: 4, tension: 0.3,
              fill: { target: 0, above: gap, below: gap }, // área entre Goal y Current
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: reduceMotion ? false : { duration: 400 },
          interaction: { mode: 'index', intersect: false }, // tooltip por mes
          scales: {
            x: {
              grid: { display: false },
              border: { color: grid },
              ticks: {
                color: currentColor,
                font: font,
                maxRotation: 0,
                autoSkip: false,
                // Cada 6 meses; en pantallas angostas, cada 12.
                callback: function (v, i) {
                  var step = this.chart.width < 480 ? 12 : 6;
                  return i % step === 0 ? 'Month ' + i : '';
                },
              },
            },
            y: {
              beginAtZero: true,
              grid: { color: grid },
              border: { display: false },
              ticks: { color: currentColor, font: font, maxTicksLimit: 6, callback: function (v) { return axisText(v); } },
            },
          },
          plugins: {
            legend: { display: false }, // leyenda en HTML, para incluir "The gap"
            tooltip: {
              backgroundColor: '#161616',
              borderColor: hexToRgba(text, 0.2),
              borderWidth: 1,
              titleFont: { family: "'Replica-Bold', sans-serif", size: 13 },
              bodyFont: font,
              padding: 10,
              callbacks: {
                title: function (items) { return 'Month ' + items[0].label; },
                label: function (item) { return item.dataset.label + ': ' + axisText(item.parsed.y); },
              },
            },
            annotation: {
              annotations: {
                currentCeiling: {
                  type: 'line', yMin: 0, yMax: 0, borderWidth: 1.5, borderDash: [6, 4], borderColor: currentColor,
                  label: Object.assign({}, label, { content: 'Current ceiling', position: 'start' }),
                },
                goalCeiling: {
                  type: 'line', yMin: 0, yMax: 0, borderWidth: 1.5, borderDash: [6, 4], borderColor: accent,
                  label: Object.assign({}, label, { content: 'Goal ceiling', position: 'end' }),
                },
              },
            },
          },
        },
      });
    }

    // No se crea otra gráfica: se reemplazan los datos y se llama chart.update().
    function renderChart(r) {
      buildChart();
      if (!chart) return;
      var a = chart.options.plugins.annotation.annotations;
      if (!r) {
        chart.data.datasets[0].data = [];
        chart.data.datasets[1].data = [];
        a.currentCeiling.display = false;
        a.goalCeiling.display = false;
        chart.update();
        return;
      }
      var s = chartSeries(r);
      var same = Math.abs(s.ceilGoal - s.ceilCur) < 1e-9;
      chart.data.datasets[0].data = s.cur;
      chart.data.datasets[1].data = s.goal;
      a.currentCeiling.display = true;
      a.currentCeiling.yMin = a.currentCeiling.yMax = s.ceilCur;
      a.goalCeiling.display = !same;
      a.goalCeiling.yMin = a.goalCeiling.yMax = s.ceilGoal;
      chart.options.scales.y.suggestedMax = Math.max(s.ceilCur, s.ceilGoal) * 1.1;
      chart.update();
    }

    function render() {
      var cur = state.currency;
      var money = function (n) { return formatMoney(n, cur); };
      var anyError = FIELDS.some(function (k) { return !!errors[k]; });
      var input = {};
      FIELDS.forEach(function (k) { input[k] = state[k]; });
      // Un error en la meta no apaga el techo: solo deja las tarjetas en "—".
      if (errors.targetSubscribers) input.targetSubscribers = NaN;
      var leverError = anyError && FIELDS.some(function (k) { return k !== 'targetSubscribers' && errors[k]; });
      var r = leverError ? null : compute(input, state.path);
      lastResult = r;

      setText('ceilSubs', r ? formatInt(r.current.ceiling) : '—');
      setText('ceilMrr', r ? money(r.current.ceilingMrr) : '—');

      setText('curCeil', r ? formatInt(r.current.ceiling) : '—');
      setText('goalCeil', r ? formatInt(r.goal.ceiling) : '—');
      setChange('chgCeil', r ? r.goal.ceiling - r.current.ceiling : null, formatInt);
      setText('curMrr', r ? money(r.current.ceilingMrr) : '—');
      setText('goalMrr', r ? money(r.goal.ceilingMrr) : '—');
      setChange('chgMrr', r ? r.goal.ceilingMrr - r.current.ceilingMrr : null, money);
      setText('curCum', r ? money(r.current.cumulative) : '—');
      setText('goalCum', r ? money(r.goal.cumulative) : '—');
      setChange('chgCum', r ? r.goal.cumulative - r.current.cumulative : null, money);

      var reached = !!(r && r.reached);
      if (reachedMsg) reachedMsg.hidden = !reached;
      if (pathsWrap) pathsWrap.hidden = reached;
      renderCard('churn', r);
      renderCard('acq', r);

      var showGoal = !!(r && r.applied);
      legendGoal.forEach(function (el) { el.classList.toggle('gc-legend__item--off', !showGoal); });
      if (copyBtn) copyBtn.hidden = !r;
      root.classList.toggle('gc--empty', !r);
      renderChart(r);
    }

    function update(options) {
      // El padding del input sigue el ancho del símbolo ("MX$" es más ancho que "$").
      symbols.forEach(function (el) {
        el.textContent = SYMBOLS[state.currency];
        var input = el.parentNode.querySelector('input');
        if (input && el.offsetWidth) input.style.paddingLeft = el.offsetLeft + el.offsetWidth + 10 + 'px';
      });
      render();
      if (!options || options.url !== false) writeUrl();
    }

    // Separador de miles mientras se escribe, sin mover el cursor.
    function formatIntLive(input) {
      var raw = input.value;
      var caret = input.selectionStart === null ? raw.length : input.selectionStart;
      var digitsBefore = raw.slice(0, caret).replace(/[^0-9]/g, '').length;
      var digits = raw.replace(/[^0-9]/g, '');
      if (digits !== raw.replace(/[,\s]/g, '')) return; // hay otros caracteres: deja que la validación lo marque
      var formatted = digits === '' ? '' : Number(digits).toLocaleString('en-US');
      input.value = formatted;
      var pos = 0;
      var seen = 0;
      while (pos < formatted.length && seen < digitsBefore) {
        if (/[0-9]/.test(formatted[pos])) seen++;
        pos++;
      }
      try {
        input.setSelectionRange(pos, pos);
      } catch (e) {}
    }

    fields.currency.addEventListener('change', function () {
      state.currency = fields.currency.value;
      update();
    });

    FIELDS.forEach(function (key) {
      var input = fields[key];
      input.addEventListener('input', function () {
        if (RULES[key].kind === 'int') formatIntLive(input);
        readField(key);
        update();
      });
      // Un valor inválido se marca solo al salir del campo.
      input.addEventListener('blur', function () {
        readField(key);
        if (errors[key]) showError(key);
        else if (Number.isFinite(state[key])) input.value = toFieldValue(key, state[key]);
      });
    });

    // "Apply this path" copia el valor resuelto al Goal. Solo se cambia entre caminos:
    // tocar el que ya está aplicado no lo quita.
    root.querySelectorAll('[data-gc-apply]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var path = btn.closest('[data-gc-path]').getAttribute('data-gc-path');
        if (lastResult && lastResult.applied === path) return;
        state.path = path;
        track('gc_path_applied', { path: path });
        update();
      });
    });

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-gc-mode');
        syncToggles();
        renderChart(lastResult);
        writeUrl();
      });
    });

    function syncToggles() {
      toggles.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-gc-mode') === state.mode ? 'true' : 'false');
      });
    }

    if (cta) cta.addEventListener('click', function () { track('gc_cta_click'); });

    // Copia el link con los números, el camino aplicado y la vista de la gráfica.
    if (copyBtn) {
      var copyLabel = copyBtn.textContent;
      var copyTimer = null;
      copyBtn.addEventListener('click', function () {
        writeUrl();
        var url = shareUrl();
        var done = function () {
          copyBtn.textContent = 'Link copied';
          clearTimeout(copyTimer);
          copyTimer = setTimeout(function () { copyBtn.textContent = copyLabel; }, 2000);
          track('gc_link_copied');
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { if (fallbackCopy(url)) done(); });
        } else if (fallbackCopy(url)) {
          done();
        }
      });
    }

    function fallbackCopy(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (e) {}
      document.body.removeChild(area);
      return copied;
    }

    syncToggles();

    update({ url: false });
  }

  var api = {
    project: project,
    ceiling: ceiling,
    cumulative: cumulative,
    solveChurn: solveChurn,
    solveAcquisition: solveAcquisition,
    compute: compute,
    parseField: parseField,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  window.GrowthCalculator = api;

  function boot() {
    document.querySelectorAll('[data-growth-calculator]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
